"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPickedFiltersWithoutRangeFilters = exports.getRangeFiltersAndRest = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _replaceSpecialCharacters = _interopRequireDefault(require("../replaceSpecialCharacters"));
var _removeAdditionalParameterFromFiltersPickedFromUrl = require("../removeAdditionalParameterFromFiltersPickedFromUrl");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SORT = "sort";
var RANGE = "range";
var getRangeFiltersAndRest = function getRangeFiltersAndRest(filters, queryFilters) {
  var regExp = new RegExp("(" + filters.filter(function (item) {
    return item.type === RANGE;
  }).map(function (item) {
    return item.id;
  }).join("|") + ")?-([\\.\\d]+)?-([\\.\\d]+)", "g");
  var results;
  var queryFiltersWithRemovedRangeFiltersPart = queryFilters;
  var queryRangeFilters = [];
  while ((results = regExp.exec(queryFilters)) !== null) {
    queryRangeFilters.push({
      filterName: results[1],
      min: Number(results[2]),
      max: Number(results[3])
    });
    queryFiltersWithRemovedRangeFiltersPart = queryFiltersWithRemovedRangeFiltersPart.replace(results[0], "");
  }
  return {
    queryRangeFilters: queryRangeFilters,
    queryFiltersWithRemovedRangeFiltersPart: queryFiltersWithRemovedRangeFiltersPart
  };
};
exports.getRangeFiltersAndRest = getRangeFiltersAndRest;
var getPickedFiltersWithoutRangeFilters = function getPickedFiltersWithoutRangeFilters(queryFiltersWithRemovedRangeFiltersPart, allFilters) {
  if (queryFiltersWithRemovedRangeFiltersPart === 0) return {};
  var queryFiltersWithRemovedRangeFiltersPartAndAdditionalParameter = (0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(decodeURI(queryFiltersWithRemovedRangeFiltersPart));
  return queryFiltersWithRemovedRangeFiltersPartAndAdditionalParameter.split("-").reduce(function (prev, filterValue) {
    var newData = _objectSpread({}, prev);
    allFilters.some(function (filter) {
      var _filter$items, _filter$items2;
      // @TODO: temporary if
      if (filter.type === RANGE) {
        filter.max = Number(filter.max);
        filter.min = Number(filter.min);
        return false;
      }
      var filterFound = ((_filter$items = filter.items) === null || _filter$items === void 0 ? void 0 : _filter$items.find(function (item) {
        return item.name === filterValue;
      })) || ((_filter$items2 = filter.items) === null || _filter$items2 === void 0 ? void 0 : _filter$items2.find(function (item) {
        return (0, _replaceSpecialCharacters["default"])(item.name).toLowerCase().replace(/ \/ /g, "_").replace(/ & /g, "_").replace(/ /g, "_") === filterValue;
      }));
      if (filterFound) {
        if (!Array.isArray(newData[filter.id])) {
          newData[filter.id] = [];
        }
        newData[filter.id] = newData[filter.id].concat(filter.items.filter(function (item) {
          return filterValue === item.name || filterValue === (0, _replaceSpecialCharacters["default"])(item.name).toLowerCase().replace(/ \/ /g, "_").replace(/ & /g, "_").replace(/ /g, "_");
        }));
        return true;
      }
    });
    return newData;
  }, {});
};
exports.getPickedFiltersWithoutRangeFilters = getPickedFiltersWithoutRangeFilters;